import { Injectable } from '@angular/core';
import { RequestsServices } from './requests.service';

@Injectable()
export class AccountsService {

    constructor(
        private request: RequestsServices
    ) { }

    updateAccountsGroup(data): any {
        return this.request.post('accounts', data, 'updateGroup');
    }

}
